import { FunctionComponent, useCallback, useState } from 'react';
import { Link } from '../../components/Link';
import { useDispatch } from 'react-redux';
import { useForm, SubmitHandler } from 'react-hook-form';

import { AuthCard } from '../../components/AuthCard';
import { Button } from '../../components/Button';
import { Form } from '../../components/Form';
import { Label, TextInput, TextFeedback } from '../../components/Input';
import { PrivacyMessage } from '../../components/PrivacyMessage';

import { showMessage } from '../../actions/message';

import { api } from '../../utils/api';
import { FormLabel } from 'react-bootstrap';

export const SignUp: FunctionComponent = () => {
  const dispatch = useDispatch();
  const [signingUp, setSigningUp] = useState(false);
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm();
  const [newsletter, setNewsletter] = useState(false);

  const onSubmit = useCallback<SubmitHandler<any>>(
    async (values) => {
      try {
        setSigningUp(true);

        await api.post(
          '/user/signup',
          {},
          {
            lang: 'it',
            email: values.email,
            privacy: '2',
            newsletter: newsletter ? '1' : '0',
            marketingCheck: newsletter ? 'on' : 'off',
            analyticsCheck: 'on',
          }
        );

        dispatch(
          showMessage({
            message:
              'Richiesta effettuata con successo. A breve riceverai una mail di attivazione.',
          })
        );
      } catch {
        dispatch(
          showMessage({
            message: 'Si è verificato un errore durante la registrazione',
            type: 'danger',
          })
        );
      } finally {
        setSigningUp(false);
      }
    },
    [dispatch, newsletter]
  );

  return (
    <AuthCard>
      <Form centered onSubmit={handleSubmit(onSubmit)}>
        <div>
          <Label>Email</Label>
          <TextInput
            {...register('email', { required: 'Questo campo è obbligatorio' })}
          />
          {errors.email && <TextFeedback>{errors.email.message}</TextFeedback>}
        </div>

        <div>
          <PrivacyMessage
            newsletterAccepted={newsletter}
            onChangeNewsletter={setNewsletter}
          />
        </div>

        <FormLabel>
          <strong>Cliccando su registrati</strong> dichiaro di avere almeno 16
          anni e che accetto i{' '}
          <a
            href={'https://lagostina.it/it/condizioni-di-uso'}
            target={'_blank'}
            rel={'noreferrer noopener'}
          >
            Termini e Condizioni
          </a>{' '}
          e la{' '}
          <a
            href={'https://lagostina.it/privacy-policy.pdf'}
            target={'_blank'}
            rel={'noreferrer noopener'}
          >
            data privacy policy
          </a>
        </FormLabel>

        <Button type={'submit'} loading={signingUp}>
          Registrati
        </Button>

        <Link to={'/'}>Sei già registrato? Clicca qui</Link>
      </Form>
    </AuthCard>
  );
};
